(function () {
  'use strict';

  /* @ngdoc object
   * @name fdpExceedanceReport
   * @description
   *
   */
  angular
    .module('fdpExceedanceReport', [
      'ui.router'
    ]);
}());
